/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { RefreshSessionResponse, RefreshSessionVars } from '../openapi-types.gen.js';

export type { RefreshSessionResponse, RefreshSessionVars } from '../openapi-types.gen.js';

export const useRefreshSession = createMutationHook<RefreshSessionVars, RefreshSessionResponse, unknown>({
  specName: 'useRefreshSession',
  path: '/v1/auth/refresh',
  method: 'POST',
  resolveUrl: (vars: RefreshSessionVars) => `/v1/auth/refresh`,
  buildBody: (vars: RefreshSessionVars) => ({ mode: vars.mode }),
  parseResponse: (raw: unknown): RefreshSessionResponse => raw as RefreshSessionResponse,
  
  
  
});
